import {eventNatureListUIHelper} from "../folder";


export const workshopsDurationUIHelper = (intl) =>
eventNatureListUIHelper(intl).map((value) => ({ eventNature: value.value, sessionTime: "01:00" }))
